import React from 'react';
import { assets, industries } from '../data/content';
import { SectionLabel } from './SectionLabel';
export function Industries() {
  return <section id="industries" aria-labelledby="industries-heading" className="w-full border-y border-warm-200 bg-white py-20 lg:py-28" data-id="element-134" data-mp="3ryyg625v2l1">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-135" data-mp="do29y2iwkdkn">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-136" data-mp="dqoh411vsr2c">
          <div className="lg:col-span-7" data-id="element-137" data-mp="rmicridn9jxi">
            <SectionLabel number="02" data-id="element-138" data-mp="mp9uziwerhws">Who we serve</SectionLabel>
            <h2 id="industries-heading" className="mt-5 font-display text-[34px] font-semibold uppercase leading-[1.02] text-ink sm:text-[44px] lg:text-[52px]" data-id="element-139" data-mp="moqfs9y577mg">
              Built for utility sites and commercial projects.
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-steel sm:text-lg" data-id="element-140" data-mp="1af471y8wl2fz">
              We serve utility companies and commercial contractors across Michigan, Indiana and
              Ohio. Our work includes the facilities and project types below.
            </p>

            <div className="mt-10 overflow-hidden" data-id="element-141" data-mp="22t8lpa9z3asw">
              <img src={assets.industries} alt="Illustrative commercial utility entrance with galvanized fencing and a double-swing gate" width={1774} height={887} loading="lazy" decoding="async" className="aspect-[16/8] w-full object-cover" data-id="element-142" data-mp="22u0hom7hfajp" />
            </div>
          </div>

          <div className="lg:col-span-5" data-id="element-143" data-mp="2qhrvju8o7vn3">
            <ul className="divide-y divide-warm-200 border-t border-ink" data-id="element-144" data-mp="2qit8y5d5su7z">
              {industries.map(item => <li key={item.title} className="py-5" data-id="element-145" data-mp="2vgcza3n4sxga">
                  <h3 className="font-display text-[22px] font-semibold uppercase leading-tight text-ink" data-id="element-146" data-mp="30ghe7p8e5k4e">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-steel" data-id="element-147" data-mp="35cy00cs4bmeb">{item.body}</p>
                </li>)}
            </ul>
            <a href="#contact" className="mt-8 inline-flex min-h-[48px] items-center rounded-sm border border-ink px-6 font-display text-[17px] uppercase tracking-[0.08em] text-ink transition-colors duration-150 ease-industrial hover:bg-ink hover:text-warm" data-id="element-148" data-mp="2aslghs1594l8">
              Discuss your site
            </a>
          </div>
        </div>
      </div>
    </section>;
}